import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  side: {
    width: theme.sizes.sideColumn
  },
  content: {
    width: theme.sizes.contentColumn
  },
  docTitle: {
    maxWidth: 470,
    paddingLeft: 32
  },
  fileNameHeader: {
    paddingLeft: 32,
    paddingRight: 12,
    width: '40%',
    fontSize: 12
  },
  documentTypeHeader: {
    paddingLeft: 12,
    paddingRight: 12,
    width: '26%',
    fontSize: 12
  },
  lastUpdateHeader: {
    paddingLeft: 12,
    paddingRight: 12,
    width: '15%',
    fontSize: 12,
    whiteSpace: 'nowrap'
  },
  docTitleCell: {
    paddingLeft: 32,
    paddingRight: 12,
    maxWidth: 320,
    overflow: 'hidden'
  },
  documentTypeCell: {
    paddingLeft: 12,
    paddingRight: 12,
    maxWidth: 190,
    overflow: 'hidden'
  },
  lastUpdateCell: {
    paddingLeft: 12,
    paddingRight: 12,
    maxWidth: 120,
    whiteSpace: 'nowrap'
  },
  truncatedText: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  smallText: {
    fontSize: 12,
    lineHeight: 1.3,
    display: 'block',
    whiteSpace: 'normal',
    wordWrap: 'break-word'
  },
  notSpecifiedText: {
    fontStyle: 'italic',
    color: theme.colorPalette.beige_75
  },
  removeButton: {
    width: 40,
    padding: 6
  },
  removeIcon: {
    width: '100%'
  },
  highlighted: {
    fontWeight: 500
  },
  noDocs: {
    padding: 12,
    textAlign: 'center'
  },
  firstCell: {
    paddingLeft: 32
  },
  docSection: {
    '& td, th': {
      padding: '4px 10px 4px 10px'
    }
  },
  modalText: {
    paddingBottom: 32
  },
  btnContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: 32
  },
  btn: {
    width: '25%'
  },
  iconContainer: {
    display: 'flex'
  },
  regularDocsTableContainer: {
    position: 'relative',
    backgroundColor: theme.colorPalette.beige_25,
    padding: '14px 32px 0px'
  },
  datePicker: {
    width: '125px',
    marginLeft: '10px',
    marginRight: '14px'
  },
  filterButton: {
    width: '85px',
    marginRight: '100px'
  },
  cantUploadContainer: {
    alignItems: 'center',
    borderTop: `solid 4px ${theme.colorPalette.orange_50}`,
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(6),
    textAlign: 'center'
  },
  cantUpload: {
    fontSize: 16,
    fontWeight: 600,
    color: theme.colorPalette.green_80
  },
  support: {
    color: theme.colorPalette.green_80
  }
});

export default makeStyles(styles);
